<a
  *ngIf="ss.branding | async"
  [href]="'https://' + (ss.branding | async).domain"
  target="_blank"
  class="z-promo-container"
>
  <span [class.z-underline]="ss.isBasic | async" [style.color]="(ss.colors | async).text80">
    {{ 'You answered an intelligent Zeffi survey' | translateText: 'promoTextZef' }}
  </span>

  <span class="z-underline" *ngIf="ss.isFree | async" [style.color]="(ss.colors | async).primary">
    {{ 'Create your own survey, fast!' | translateText: 'promoTextLink' }}
  </span>
</a>
